import { Button, Col, Form, Row, Select, Space } from 'antd';
import { useEffect, useState } from 'react';

const { Option } = Select;

interface RegisterFAComponent2Props {
  onPrev: () => void;
  onNext: (data: any) => void;
}

function RegisterFAComponent2({ onPrev, onNext }: RegisterFAComponent2Props) {
  const [form] = Form.useForm();
  const [cardOrgListOptions, setCardOrgListOptions] = useState<any[]>([]);

  useEffect(() => {
    const cardOrgNameList = [
      { name: 'KB카드', value: '0301' },
      { name: '현대카드', value: '0302' },
      { name: '삼성카드', value: '0303' },
      { name: 'NH카드', value: '0304' },
      { name: 'BC카드', value: '0305' },
      { name: '신한카드', value: '0306' },
      { name: '씨티카드', value: '0307' },
      { name: '우리카드', value: '0309' },
      { name: '롯데카드', value: '0311' },
      { name: '하나카드', value: '0313' },
      { name: '전북카드', value: '0315' },
      { name: '광주카드', value: '0316' },
      { name: '수협카드', value: '0320' },
      { name: '제주카드', value: '0321' },
      { name: '산업은행카드', value: '0002' },
    ];
    let children: any = [];
    for (const cardOrg of cardOrgNameList.sort((x, y) =>
      x.name.localeCompare(y.name),
    )) {
      children.push(
        <Option key={cardOrg.value} value={cardOrg.value}>
          {cardOrg.name}
        </Option>,
      );
    }
    setCardOrgListOptions(children);
  }, []);

  return (
    <>
      <Form
        form={form}
        initialValues={{ organizationCode: '0311' }}
        onFinish={() => {
          form
            .validateFields()
            .then((values) => {
              onNext(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="organizationCode"
              label="카드사"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }}>{cardOrgListOptions}</Select>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: '50px' }}>
          <Col span={18}>
            <Form.Item>
              <Row justify="center">
                <Space size="middle">
                  <Button htmlType="button" onClick={onPrev}>
                    뒤로
                  </Button>
                  <Button type="primary" htmlType="submit">
                    다음
                  </Button>
                </Space>
              </Row>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}
export default RegisterFAComponent2;
